export class PageText {
  pageText;
  constructor() {}

  init() {
    this.pageText = document.querySelectorAll('.page-text');
    if (!this.pageText || this.pageText.length === 0) return;

    if (document.querySelector('.page-text-mobile-more')) {
      this.initShowHide();
    }

    // if (document.querySelector('.page-text-video')) {
    //   this.initVideo();
    // }
  }

  initShowHide() {
    this.pageText.forEach((el) => {
      const more = el.querySelector('.page-text-mobile-more');
      if (more) {
        more.addEventListener('click', () => {
          if (more.classList.contains('showed')) {
            this.hideText(el, more);
          } else {
            this.showText(el, more);
          }
        });
      }
    });
  }

  hideText(parent, button) {
    button.classList.remove('showed');
    parent.querySelector('.page-text-mobile-hidden').classList.remove('show');
  }

  showText(parent, button) {
    button.classList.add('showed');
    parent.querySelector('.page-text-mobile-hidden').classList.add('show');
  }

  // initVideo() {
  //   this.pageText.forEach((el) => {
  //     const video = el.querySelectorAll('.page-text-video');
  //     if (video && video.length > 0) {
  //       video.forEach((videoEl) => {
  //         videoEl
  //           .querySelector('.page-text-video-play')
  //           .addEventListener('click', () => {
  //             const cover = videoEl.querySelector('.page-text-video-cover');
  //             cover.classList.add('hide-animation');
  //             setTimeout(() => {
  //               cover.classList.add('hide');
  //               videoEl.querySelector('video').play();
  //             }, 400);
  //           });
  //       });
  //     }
  //   });
  // }
}
